// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const CirclePositioner = require('client-v2/common/components/circle-positioner')
const { CollectionSubscribeCircleButton } = require('client-v2/common/components/buttons')
const LazyImage = require('client-v2/common/components/lazy-image')
const UserAvatar = require('client-v2/common/components/user-avatar')
const CollectionModelRecord = require('client-v2/common/models/collection/record')

const bem = BemEntity('TopCallToActionCollectionCard')

class TopCallToActionCollectionCard extends React.PureComponent {

  // Render methods

  renderCaption() {
    return tag('div', {
      className: bem.element('caption')
    },
      'Collection'
    )
  }

  renderCollectionName() {
    const { name } = this.props.collection
    return tag('span', {
      className: bem.element('collection-name')
    },
      name
    )
  }

  renderDetails() {
    return tag('div', {
      className: bem.element('details')
    },
      tag('div', {
        className: bem.element('details-top')
      },
        this.renderCaption(),
        this.renderCollectionName()
      ),
      tag('div', {
        className: bem.element('details-bottom')
      },
        this.renderUserName(),
        this.renderUserPhoto()
      )
    )
  }

  renderImage() {
    const { collection, placeholderImage } = this.props
    return tag('div', {
      className: bem.element('image-container')
    },
      tag(LazyImage, {
        className: bem.element('image'),
        placeholder: placeholderImage,
        sources: collection.images
      }),
      tag('div', {
        className: bem.element('image-overlay')
      })
    )
  }

  renderPositionedCircleContent() {
    if (!this.props.onFollowClick) {
      return null
    }
    return tag(CirclePositioner, {
      className: bem.element('positioned')
    },
      this.renderSubscribeButton()
    )
  }

  renderSubscribeButton() {
    const { isFollowing } = this.props.collection
    return tag(CollectionSubscribeCircleButton, {
      className: bem.element('subscribe-button'),
      checked: isFollowing,
      onClick: this.props.onFollowClick
    })
  }

  renderUserName() {
    const { username } = this.props.collection
    return tag('span', {
      className: bem.element('user-byline')
    },
      `Created by - `,
      tag('em', {
        className: bem.element('user-name')
      },
        `@${username}`
      )
    )
  }

  renderUserPhoto() {
    return tag(UserAvatar, {
      className: bem.element('user-photo'),
      user: this.props.collection
    })
  }

  render() {
    return tag('div', {
      className: classNames(
        this.props.className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('inner')
      },
        this.renderImage(),
        this.renderDetails(),
        this.renderPositionedCircleContent()
      )
    )
  }
}

TopCallToActionCollectionCard.propTypes = {
  // Flags
  // Values
  className: PropTypes.string,
  collection: PropTypes.shape(CollectionModelRecord.propTypes).isRequired,
  placeholderImage: PropTypes.string,
  // Callbacks
  onFollowClick: PropTypes.func
}

module.exports = TopCallToActionCollectionCard
